import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { t } from "i18next";

/**
 * Help component for Languages column
 * @returns {JSX.Element} MDBox with help text
 */
const LanguagesHelp = () => {
	return (
		<MDBox>
			<MDTypography variant="body2">{t("ASSETS.THEME.languageHelp")}</MDTypography>
		</MDBox>
	);
};

export default LanguagesHelp;
